import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { addDesktopItemToLast, pushToVersions, setCustomCollectionToEdit, setModal, setSectionFormType, updateVersionIndex } from '../../../../../Features/storefrontSlice';
import ChevronGray from '../../../../../Assets/StorefrontIcons/ChevronGray.svg';
import CrossGray from '../../../../../Assets/StorefrontIcons/CrossGray.svg';
import { getCustomCollection } from '../../../../../lib/utils/apiCalls';
import { v4 as uuidv4 } from 'uuid';

function CustomCollectionsListDesktopForm() {
    const dispatch = useDispatch();

    const customCollectionToEdit = useSelector((state) => state.storefront.customCollectionToEdit);
    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const [customCollectionId, setCustomCollectionId] = useState('');

    const {
        customCollectionDesktop,
        setCustomCollectionDesktop,
    } = useContext(StorefrontContext);

    const defaultFormErrors = {
        title: '',
        customCollectionId: ''
    }
    
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    function closeForm() {
        dispatch(setSectionFormType(null));
        setCustomCollectionDesktop({
            title: '',
            customCollection: {},
        });
    }

    function handleChange(e) {
        setCustomCollectionDesktop({
            ...customCollectionDesktop,
            title: e.target.value,
        });
    }

    function handleSave() {
        if(customCollectionId) {
            const currentVersion = versionStack[versionIndex];
        
            const tempVersionData = [ ...currentVersion.versionData ];
            const tempWebVersionData = [ ...currentVersion.webVersionData ];

            const categoryCollectionDataIndex = tempVersionData.findIndex(
                item =>
                    item.item.typeData === 'CUSTOM_COLLECTION_LIST' && 
                    item.item.id === customCollectionId 
            );

            const categoryCollectionDesktopDataIndex = tempWebVersionData.findIndex(
                item =>
                    item.item.typeData === 'CUSTOM_COLLECTION_LIST' && 
                    item.item.id === customCollectionId 
            );
        
            if (categoryCollectionDataIndex !== -1) {
                tempVersionData[categoryCollectionDataIndex] = {
                    ...tempVersionData[categoryCollectionDataIndex],
                    item: {
                        ...tempVersionData[categoryCollectionDataIndex].item,
                        name: customCollectionDesktop.title,
                        customCollectionList: [String(customCollectionDesktop.customCollection.id)],
                    }
                };
            }

            if (categoryCollectionDesktopDataIndex !== -1) {
                tempWebVersionData[categoryCollectionDesktopDataIndex] = {
                    ...tempWebVersionData[categoryCollectionDesktopDataIndex],
                    item: {
                        ...tempWebVersionData[categoryCollectionDesktopDataIndex].item,
                        name: customCollectionDesktop.title,
                        customCollectionList: [String(customCollectionDesktop.customCollection.id)],
                    }
                };
            }

            const newIndex = versionStack[versionStack.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: tempVersionData,
                webVersionData: tempWebVersionData,
                comment: 'Update desktop custom collection list',
            }

            dispatch(pushToVersions(newVersion));
            dispatch(updateVersionIndex(newIndex));
        }
        else {
            const validationErrors = {};

            if(!customCollectionDesktop.title) {
                validationErrors.title = 'Required field';
            }
            if(Object.keys(customCollectionDesktop.customCollection).length === 0) {
                validationErrors.customCollectionId = 'Required field';
            }

            if(Object.keys(validationErrors).length === 0) {
                const object = {
                    typeData: 'CUSTOM_COLLECTION_LIST',
                    name: customCollectionDesktop.title,
                    id: uuidv4(),
                    customCollectionList: [customCollectionDesktop.customCollection.id],
                }

                dispatch(addDesktopItemToLast(object));
            }
            else {
                setFormErrors(validationErrors);
            }
        }
        closeForm();
    }

    function handleOpenCategoryCollectionModal() {
        dispatch(setModal('select-custom-collection'));
    }

    useEffect(() => {
        async function setCustomCollectionLocal(id) {
            if(id) {
                const tempVersion = versionStack[versionIndex]?.webVersionData;

                if (tempVersion && tempVersion.length > 0) {
                    const foundItem = tempVersion.find(item => item.item.typeData === 'CUSTOM_COLLECTION_LIST' && item.item.id === id);

                    if(foundItem) {
                        const { item } = foundItem;

                        let customCollectionObject = {};

                        try {
                            const response = await getCustomCollection(item?.customCollectionList[0]);
                            if(response.status === 200) {
                                customCollectionObject = { ...response.data.data.collection };
                            }
                        }
                        catch(err) {
                            console.log(err);
                        }

                        setCustomCollectionDesktop({
                            title: item.name,
                            customCollection: customCollectionObject,
                        });
                        setCustomCollectionId(id);
                    }
                }
            }
        }

        setCustomCollectionLocal(customCollectionToEdit);
        dispatch(setCustomCollectionToEdit(null));
        // eslint-disable-next-line
    }, [customCollectionToEdit]);

    return (
        <div className='w-[305px] h-full bg-[#FFFFFF] border-l border-[#EAEAEA] flex flex-col gap-4 select-none relative'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>Custom Collection List</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={closeForm} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col gap-3 px-3 overflow-y-scroll no-scrollbar pb-16">
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between">
                        <label htmlFor="title" className='font-medium text-[14px] leading-[22px] text-[#121212]'>Section name</label>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.title}</p>
                    </div>

                    <input 
                        name='title' 
                        id='title' 
                        className='outline-none border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] text-[#121212] placeholder:text-[#666666]' 
                        placeholder='Enter section name' 
                        type="text" 
                        value={customCollectionDesktop.title} 
                        onChange={handleChange} 
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <p className='font-medium text-base text-[#000000]'>Link to</p>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.customCollectionId}</p>
                    </div>

                    <button onClick={handleOpenCategoryCollectionModal} className="outline-none p-3 border border-[#EAEAEA] bg-[#F5F5F5] flex items-center gap-[10px] rounded-[9px]">
                        <p className='w-[calc(100%-24px)] line-clamp-1 font-normal text-base text-[#666666] text-left'>
                            {Object.keys(customCollectionDesktop.customCollection).length > 0 ? `${customCollectionDesktop.customCollection.CollectionName}` : 'custom collection'}
                        </p>

                        <div className="size-6 flex items-center justify-center">
                            <img src={ChevronGray} alt="" />
                        </div>
                    </button>
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full p-3 bg-[#FFFFFF]">
                <button onClick={handleSave} className='w-full outline-none px-4 py-[6px] bg-primaryColor hover:bg-primaryAccent rounded-md font-semibold text-[12px] leading-6 text-buttonText'>Save changes</button>
            </div>
        </div>
    );
}

export default CustomCollectionsListDesktopForm;
